<div *ngIf="permissionAccess">
    <div class="header-title">
        <h2>
          <mat-icon style="position:relative;top:5px;">view_list</mat-icon>
          <span>Subir Lista de Personas Bloqueadas</span>
        </h2>
        <hr>
    </div>

    <div class="row">
        <div class="col-sm-12 col-lg-8 pt-5">
            <div class="form-group">
                <div style="display: flex; gap: 5px; align-items: center;">
                    <label class="form-control-label"><b>Selecione archivo csv</b><span class="text-danger"> * </span></label>
                </div>
                <div class="uploadFile">
                    <input class="form-control" accept=".csv" type="file" (change)="getInfoLPB($event)" 
                       formControlName="listPersonBlockedFile" name="listPersonBlockedFile" class="form-control-file border">
                    <i class="fa fa-upload fa-2x"></i>
                </div> 
            </div>         
        </div>
    </div>
    <div class="row d-flex justify-content-center">
        <div class="form-group col-sm-6 col-md-2 col-lg-2 col-xl-2 pt-3"> 
            <button type="button" class="btn btn-primary" (click)="onSentDataPerson()">Enviar Información</button> </div>
    </div>
</div>
<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>